(() => {
  'use strict';

  const INITIALIZED_KEY = '__aknesImageProtectionInitialized';
  const SCOPE_SELECTOR = '[data-aknes-image-protection="true"]';
  const IMAGE_SELECTOR = 'img:not([data-aknes-image-protection-ignore="true"])';
  const IGNORE_SELECTOR = '[data-aknes-image-protection-ignore="true"]';
  const CAROUSEL_GUARD_SELECTOR = '[data-aknes-carousel-media-guard]';

  if (window[INITIALIZED_KEY]) return;
  window[INITIALIZED_KEY] = true;

  const getEventPath = (event) => {
    if (typeof event.composedPath === 'function') return event.composedPath();
    return event.target ? [event.target] : [];
  };

  const findProtectedImage = (event) => {
    for (const node of getEventPath(event)) {
      if (!(node instanceof Element)) continue;
      if (node.closest(IGNORE_SELECTOR)) return null;

      const image = node.matches(IMAGE_SELECTOR) ? node : node.closest(IMAGE_SELECTOR);
      if (!image) continue;

      const scope = image.closest(SCOPE_SELECTOR);
      if (scope) return { image, scope };
    }

    return null;
  };

  const findProtectedCarouselGuard = (event) => {
    for (const node of getEventPath(event)) {
      if (!(node instanceof Element)) continue;

      const guard = node.matches(CAROUSEL_GUARD_SELECTOR)
        ? node
        : node.closest(CAROUSEL_GUARD_SELECTOR);
      if (!guard) continue;

      const scope = guard.closest(SCOPE_SELECTOR);
      if (scope) return { guard, scope };
    }

    return null;
  };

  const getProtectionMode = (scope) =>
    scope.getAttribute('data-aknes-image-protection-mode') || 'standard';

  const disableNativeImageDragging = (root = document) => {
    const scopes = [];

    if (root instanceof Element && root.matches(SCOPE_SELECTOR)) scopes.push(root);
    if (root instanceof Document || root instanceof Element) {
      scopes.push(...root.querySelectorAll(SCOPE_SELECTOR));
    }

    scopes.forEach((scope) => {
      scope.querySelectorAll(IMAGE_SELECTOR).forEach((image) => {
        if (image.closest(IGNORE_SELECTOR)) return;
        image.draggable = false;
        image.setAttribute('draggable', 'false');
      });
    });
  };

  document.addEventListener(
    'contextmenu',
    (event) => {
      const guardMatch = findProtectedCarouselGuard(event);
      if (guardMatch) {
        if (getProtectionMode(guardMatch.scope) !== 'standard') return;
        if (event.cancelable) event.preventDefault();
        return;
      }

      const match = findProtectedImage(event);
      if (!match) return;
      if (getProtectionMode(match.scope) !== 'standard') return;
      if (event.cancelable) event.preventDefault();
    },
    { capture: true, passive: false }
  );

  document.addEventListener(
    'dragstart',
    (event) => {
      const protectedTarget = findProtectedCarouselGuard(event) || findProtectedImage(event);
      if (protectedTarget && event.cancelable) event.preventDefault();
    },
    { capture: true, passive: false }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => disableNativeImageDragging(), { once: true });
  } else {
    disableNativeImageDragging();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) disableNativeImageDragging(event.target);
  });
})();
